module.exports = __webpack_public_path__ + "img/iconos-ilustracion-06.6f6952ae.jpg";